import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReturnWorkflowOverviewIconBlue = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 14,
	viewBox: "0 0 26 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M1.42871 7.07617L24.8809 7.07617",
			stroke: "#001489",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			style: { mixBlendMode: "multiply" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 13.5L1 7L7 0.5",
			stroke: "#001489",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			style: { mixBlendMode: "multiply" }
		})
	]
});
const ForwardRef = forwardRef(SvgReturnWorkflowOverviewIconBlue);
export default ForwardRef;
